'use client';

import PageType from '@alltrails/amplitude/enums/PageType';
import { LOCATION_SECTION_ID_VISITOR_INFO } from '@/constants/locationSectionIds';

type Props = {
  children: React.ReactNode;
  pageType: PageType;
};

const ParkSectionWrapper = ({ children }: Props) => {
  return <div id={LOCATION_SECTION_ID_VISITOR_INFO}>{children}</div>;
};

export default ParkSectionWrapper;
